module.exports = __webpack_public_path__ + "static/media/t43.44ee8b13.jpg";